const { buildMillaAuthUrl } = require('../utils/millaAuth');
const { buildInsightsPublicUrl } = require('./urls');

function storageKey(brand) {
  return `milla_anon:${brand === 'mtlblog' ? 'mtlblog' : 'narcity'}`;
}

function readStoredAnonId(brand) {
  if (typeof window === 'undefined') return '';
  try {
    return window.localStorage?.getItem(storageKey(brand)) || '';
  } catch (_) {
    return '';
  }
}

function storeAnonId(brand, anonId) {
  if (typeof window === 'undefined' || !anonId) return;
  try {
    window.localStorage?.setItem(storageKey(brand), anonId);
  } catch (_) {
    // ignore storage failures
  }
}

async function adoptAnonId(brand, anonId, options = {}) {
  if (!anonId) return null;
  try {
    const url = options.publicInsights === true
      ? buildInsightsPublicUrl('/api/insights/anon/adopt')
      : buildMillaAuthUrl('/api/insights/anon/adopt');
    const res = await fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ anonId })
    });
    const data = await res.json().catch(() => null);
    if (!res.ok || data?.success === false) return null;
    storeAnonId(brand, data.anonId || anonId);
    return data.anonId || anonId;
  } catch (_) {
    return null;
  }
}

module.exports = {
  readStoredAnonId,
  storeAnonId,
  adoptAnonId
};
